import { Component } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  template: '<h2>I am dynamically attached</h2>'
})
export class PageNotFoundComponent {}
